import script from "./SignatureSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureSection.vue?vue&type=script&setup=true&lang=js"

import "./SignatureSection.vue?vue&type=style&index=0&id=21b8f286&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b8f286"]])

export default __exports__